export default "__VITE_ASSET__ZnmCNVXc__"